/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type ChatRoomStatus =
  /** 要対応(OA向けに作ったものだが、一般にも使えるようなenumにする) */
  | 'ActionRequired'
  /** 面談済み・対応中 */
  | 'Appointed'
  /** 対応不要 */
  | 'Archived'
  /** 契約済み */
  | 'ContractConcluded'
  /** 保険契約済み */
  | 'ContractConcludedInsurance'
  /** 証券契約済み */
  | 'ContractConcludedSecurities'
  /** 不満足の表明(OA向けに作ったものだが、一般にも使えるようなenumにする) */
  | 'GotComplaints'
  /** 後追い対応 */
  | 'Keeping'
  /** 失注 */
  | 'LostOrder'
  /** チャット対応中 */
  | 'Messaging'
  /** 未設定 */
  | 'NotDefined'
  /** 面談設定中 */
  | 'Offering'
  /** 初回面談実施待ち */
  | 'WaitingForFirstAppointment';

export type Prefecture =
  | 'Aichi'
  | 'Akita'
  | 'Aomori'
  | 'Chiba'
  | 'Ehime'
  | 'Fukui'
  | 'Fukuoka'
  | 'Fukushima'
  | 'Gifu'
  | 'Gunma'
  | 'Hiroshima'
  | 'Hokkaido'
  | 'Hyogo'
  | 'Ibaraki'
  | 'Ishikawa'
  | 'Iwate'
  | 'Kagawa'
  | 'Kagoshima'
  | 'Kanagawa'
  | 'Kochi'
  | 'Kumamoto'
  | 'Kyoto'
  | 'Mie'
  | 'Miyagi'
  | 'Miyazaki'
  | 'Nagano'
  | 'Nagasaki'
  | 'Nara'
  | 'Niigata'
  | 'Oita'
  | 'Okayama'
  | 'Okinawa'
  | 'Osaka'
  | 'Saga'
  | 'Saitama'
  | 'Shiga'
  | 'Shimane'
  | 'Shizuoka'
  | 'Tochigi'
  | 'Tokushima'
  | 'Tokyo'
  | 'Tottori'
  | 'Toyama'
  | 'Wakayama'
  | 'Yamagata'
  | 'Yamaguchi'
  | 'Yamanashi';

export type UserGender =
  | 'FEMALE'
  | 'MALE'
  | 'NO_ANSWER'
  | 'OTHER';

export type MemberChatRoomListQueryVariables = Exact<{
  first: number;
  after?: string | null | undefined;
}>;


export type MemberChatRoomListQuery = { colleagueChatRooms: { edges: Array<{ cursor: string, node: { id: string, updatedAt: TimeString, status: Types.ChatRoomStatus, match: { id: string, normalMessageChatReplyMatchSetting: { disabledUntil: TimeString | null } }, user: { id: string, birthYear: number | null, nickname: string, gender: Types.UserGender, livingPrefecture: Types.Prefecture | null, address: { prefecture: string, city: string } | null } | null, planner: { id: string, name: string, avatar: any } } } | null> | null, pageInfo: { endCursor: string | null, hasNextPage: boolean } } | null };

export type MemberChatRoomListUserFragment = { id: string, birthYear: number | null, nickname: string, gender: Types.UserGender, livingPrefecture: Types.Prefecture | null, address: { prefecture: string, city: string } | null };

export const MemberChatRoomListUserFragmentDoc = gql`
    fragment MemberChatRoomListUser on User {
  id
  birthYear
  nickname
  gender
  livingPrefecture
  address {
    prefecture
    city
  }
}
    `;
export const MemberChatRoomListDocument = gql`
    query MemberChatRoomList($first: Int!, $after: String) {
  colleagueChatRooms(first: $first, after: $after) {
    edges {
      cursor
      node {
        id
        updatedAt
        status
        match {
          id
          normalMessageChatReplyMatchSetting {
            disabledUntil
          }
        }
        user {
          ...MemberChatRoomListUser
        }
        planner {
          id
          name
          avatar
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${MemberChatRoomListUserFragmentDoc}`;

/**
 * __useMemberChatRoomListQuery__
 *
 * To run a query within a Vue component, call `useMemberChatRoomListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberChatRoomListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMemberChatRoomListQuery({
 *   first: // value for 'first'
 *   after: // value for 'after'
 * });
 */
export function useMemberChatRoomListQuery(variables: MemberChatRoomListQueryVariables | VueCompositionApi.Ref<MemberChatRoomListQueryVariables> | ReactiveFunction<MemberChatRoomListQueryVariables>, options: VueApolloComposable.UseQueryOptions<MemberChatRoomListQuery, MemberChatRoomListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MemberChatRoomListQuery, MemberChatRoomListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MemberChatRoomListQuery, MemberChatRoomListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MemberChatRoomListQuery, MemberChatRoomListQueryVariables>(MemberChatRoomListDocument, variables, options);
}
export function useMemberChatRoomListLazyQuery(variables?: MemberChatRoomListQueryVariables | VueCompositionApi.Ref<MemberChatRoomListQueryVariables> | ReactiveFunction<MemberChatRoomListQueryVariables>, options: VueApolloComposable.UseQueryOptions<MemberChatRoomListQuery, MemberChatRoomListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MemberChatRoomListQuery, MemberChatRoomListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MemberChatRoomListQuery, MemberChatRoomListQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<MemberChatRoomListQuery, MemberChatRoomListQueryVariables>(MemberChatRoomListDocument, variables, options);
}
export type MemberChatRoomListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MemberChatRoomListQuery, MemberChatRoomListQueryVariables>;